export default __webpack_public_path__ + "static/media/jwelleryadd.dc7338be.jpg";